// extracted by mini-css-extract-plugin
module.exports = {"root":"Tabs_root__2chTH","tab":"Tabs_tab__22KoY","tabActive":"Tabs_tabActive__iTIVg"};